import range from 'lodash/fp/range';

export type ScrollPaginationProps<T extends { key: string }[]> = {
  list: T;
  limit: number;
  preset: number;
};

const getPages = <T extends any[]>(list: T, limit: number) =>
  list.reduce((acc, item, i) => {
    const pageNumber = Math.floor(i / limit);
    if (!acc[pageNumber]) acc[pageNumber] = [];

    acc[pageNumber].push(item);

    return acc;
  }, [] as [][]);

export default <T extends any[]>({ list, limit, preset }: ScrollPaginationProps<T>) => {
  const pages = getPages(list, limit);
  //   const totalPages = pages.length; TODO add functional soon
  const currentPages = [] as [][];
  let currentPageNumber = 0;

  //   const prev = () => {}; TODO add functional soon

  const next = (nextPageNumber = currentPageNumber) => {
    const page = pages[nextPageNumber];

    currentPages[nextPageNumber] = page;
    currentPageNumber += 1;

    return currentPages;
  };

  const initPreset = () => range(0, preset).reduce((_, pageNumber) => next(pageNumber), []);

  initPreset();

  return { currentPages, next };
};
